import React from 'react';
import { Toolbar } from './components';

export function editToolbar({ step, setStep, ...props }) {
  return <Toolbar step={step} setStep={setStep} {...props} />;
}
export function createToolbar({ step, setStep, ...props }) {
  return <Toolbar step={step} setStep={setStep} {...props} />;
}
